import React from "react";
import LegalLayout, { LegalBlock } from "@/components/legal/LegalLayout";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useConsent } from "@/lib/consent";

const COOKIES = [
  { name: "etap_consent", purpose: "Stores your cookie consent choice and version", provider: "ETAP", category: "Strictly Necessary", lifespan: "12 months" },
  { name: "session", purpose: "Keeps the site secure and balanced under load", provider: "Infrastructure", category: "Strictly Necessary", lifespan: "Session" },
  { name: "_ga", purpose: "Distinguishes users for aggregate analytics", provider: "Google Analytics", category: "Analytics", lifespan: "24 months, loads only with consent" },
  { name: "_gid", purpose: "Distinguishes users for aggregate analytics", provider: "Google Analytics", category: "Analytics", lifespan: "24 hours, loads only with consent" },
];

export default function CookiePolicy() {
  const { openPreferences } = useConsent();
  return (
    <LegalLayout
      title="Cookie Policy"
      seoTitle="Cookie Policy | ETAP"
      description="What cookies ETAP uses, why, and how to control them. Analytics and marketing cookies load only after you grant consent. Manage your preferences anytime."
      path="/cookie-policy"
      lastUpdated="To be confirmed by counsel"
      intro="This template explains the cookies ETAP uses and the control you have. Nothing beyond strictly necessary cookies loads until you allow it."
    >
      <LegalBlock heading="How we use cookies">
        <p>
          We use a small number of cookies to run the site and, only with your permission, to understand which pages are
          useful. You can accept, reject, or choose per category, and you can change your mind at any time.
        </p>
        <p>
          <button
            type="button"
            onClick={openPreferences}
            className="font-semibold text-etap-primary underline underline-offset-2"
            data-testid="cookie-policy-open-prefs"
          >
            Open cookie preferences
          </button>
        </p>
      </LegalBlock>

      <LegalBlock heading="Cookies we set">
        <div className="overflow-x-auto rounded-2xl border border-etap-deep-100 bg-white">
          <Table>
            <TableHeader>
              <TableRow className="bg-etap-deep-50">
                <TableHead className="text-etap-deep-700">Cookie</TableHead>
                <TableHead className="text-etap-deep-700">Purpose</TableHead>
                <TableHead className="text-etap-deep-700">Provider</TableHead>
                <TableHead className="text-etap-deep-700">Category</TableHead>
                <TableHead className="text-etap-deep-700">Lifespan</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {COOKIES.map((c) => (
                <TableRow key={c.name}>
                  <TableCell className="font-semibold text-etap-deep-800">{c.name}</TableCell>
                  <TableCell className="text-etap-deep-600">{c.purpose}</TableCell>
                  <TableCell className="text-etap-deep-600">{c.provider}</TableCell>
                  <TableCell className="text-etap-deep-600">{c.category}</TableCell>
                  <TableCell className="text-etap-deep-600">{c.lifespan}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </LegalBlock>

      <LegalBlock heading="Managing cookies">
        <p>
          Use the preference center to allow or reject analytics and marketing cookies. Withdrawal takes effect
          immediately. You can also control cookies in your browser settings.
        </p>
      </LegalBlock>

      <LegalBlock heading="Contact">
        <p>
          Questions about cookies can be sent to{" "}
          <a href="mailto:privacy@etaptax.com" className="font-semibold text-etap-primary underline underline-offset-2">
            privacy@etaptax.com
          </a>
          .
        </p>
      </LegalBlock>
    </LegalLayout>
  );
}
